const allEqual = (arr, value) => arr.every(v => v === value )
export default allEqual